import { getImage, getLink } from "./getElements"

export interface Property {
  propertyName: string
  propertyValue: any
}

export const transformProperties = (
  propertiesArray: any,
): Record<string, any> => {
  if (!propertiesArray) return []
  return propertiesArray.reduce(
    (acc: { [x: string]: any }, { propertyName, propertyValue }: any) => {
      if (
        propertyValue &&
        typeof propertyValue === "object" &&
        "__typename" in propertyValue
      ) {
        const { __typename, ...rest } = propertyValue
        acc[propertyName] = rest
      } else {
        acc[propertyName] = propertyValue
      }
      return acc
    },
    {} as Record<string, any>,
  )
}

export enum FieldType {
  IMAGE = "MintMediaPicker",
  TEXT = "BasicPropertyValue",
  LINK = "BasicMultiUrlPicker",
  BLOCK = "BasicBlockListModel",
  RICH_TEXT = "BasicRichText",
}

export const extractBlockProperties = (blockItems: any) => {
  if (!blockItems) return null
  if (blockItems?.length === 0) return []

  const result = blockItems.map((item: any) => {
    const properties = executeFormatting(item.properties)
    return properties
  })
  return result
}

export const executeFormatting = <T>(properties: Property[]): T => {
  const allProperties = transformProperties(properties)
  const result = Object.entries(allProperties).reduce(
    (acc: any, curr: [string, any]) => {
      const propertyName: keyof T = curr[0] as keyof T
      const values: any = Object.values(curr[1])
      const propertyValue = values[1]
      const propertyType: FieldType = values[0]
      const formatFunction = valueByFieldType[propertyType]
      acc[propertyName] = formatFunction(propertyValue)
      return acc
    },
    {},
  )
  return result
}

export const valueByFieldType: Record<FieldType, (value: any) => any> = {
  [FieldType.IMAGE]: (image) => {
    return getImage(image[0])
  },
  [FieldType.TEXT]: (value: string) => value,
  [FieldType.LINK]: (link) => getLink(link[0]),
  [FieldType.BLOCK]: extractBlockProperties,
  [FieldType.RICH_TEXT]: (richText) => richText,
}
